import { InjectionToken, Injectable, ɵɵdefineInjectable, NgModule, Pipe, ɵɵinject, Inject } from '@angular/core';
import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import { createEntityAdapter } from '@ngrx/entity';
import Debug from 'debug';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modeso-core.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function Config() { }
if (false) {
    /** @type {?} */
    Config.prototype.apiGateway;
}
/** @type {?} */
const ConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modeso-core.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoCoreService {
    constructor() { }
}
ModesoCoreService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
ModesoCoreService.ctorParameters = () => [];
/** @nocollapse */ ModesoCoreService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ModesoCoreService_Factory() { return new ModesoCoreService(); }, token: ModesoCoreService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * Generated from: lib/modeso-core.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoCoreModule {
}
ModesoCoreModule.decorators = [
    { type: NgModule, args: [{
                declarations: [],
                imports: [],
                exports: []
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/namedString.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * A class which represent a named string.
 * Can be used for a localized string for instance
 *
 */
class NamedString {
    /**
     * @param {?} key
     * @param {?} text
     */
    constructor(key, text) {
        this.key = key;
        this.text = text;
    }
}
if (false) {
    /** @type {?} */
    NamedString.prototype.key;
    /** @type {?} */
    NamedString.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/namedString.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getLocalizations = createAction('[modeso-core] getLocalizations');
/** @type {?} */
const onLocalizationsLoadedSuccessfully = createAction('[modeso-core] all localizations loaded successfully', props());
/** @type {?} */
const onLocalizationsLoadingFailed = createAction('[modeso-core] all localizations loading failed', props());
/** @type {?} */
const getLocalizationByKey = createAction('[modeso-core] getLocalizationByKey', props());
/** @type {?} */
const onLocalizationByKeyLoadedSuccessfully = createAction('[modeso-core] LocalizationByKey loaded successfully', props());
/** @type {?} */
const onLocalizationByKeyLoadingFailed = createAction('[modeso-core] LocalizationByKey loading failed', props());
/**
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/**
 * @record
 */
function ActionWithContentId() { }
if (false) {
    /** @type {?} */
    ActionWithContentId.prototype.key;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/namedString.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'namedStrings';
// State Declarations - START
/** @type {?} */
const adapter = createEntityAdapter({
    selectId: selectContentId,
    sortComparer: sortById
});
/**
 * @param {?} a
 * @return {?}
 */
function selectContentId(a) {
    return a.key;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sortById(a, b) {
    return a.key.localeCompare(b.key);
}
/**
 * @record
 */
function FeatureState() { }
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.namedStrings;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.namedStrings);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureContent = createSelector(selectFeature, (ɵ0));
const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
/** @type {?} */
const selectLocalizationEntities = createSelector(selectFeatureContent, selectEntities);
/** @type {?} */
const selectContentAllEntities = createSelector(selectFeatureContent, selectAll);
const ɵ1 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectEntitiesByID = createSelector(selectLocalizationEntities, (ɵ1));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = adapter.getInitialState();
const ɵ2 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ3 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.upsertMany(action.payload, Object.assign({}, state));
}, ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ6 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.upsertOne(action.payload, Object.assign({}, state));
}, ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state));
/** @type {?} */
const contentReducer = createReducer(initialState, on(getLocalizations, (ɵ2)), on(onLocalizationsLoadedSuccessfully, (ɵ3)), on(onLocalizationsLoadingFailed, (ɵ4)), on(getLocalizationByKey, (ɵ5)), on(onLocalizationByKeyLoadedSuccessfully, (ɵ6)), on(onLocalizationByKeyLoadingFailed, (ɵ7)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return contentReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/injectedText.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InjectedTextPipe {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        console.log('InjectedTextPipe constructed');
    }
    /**
     * @param {?} key
     * @return {?}
     */
    transform(key) {
        return this.store.pipe(select(selectEntitiesByID, { id: key }), map((/**
         * @param {?} localization
         * @return {?}
         */
        (localization) => {
            if (localization) {
                return localization.text;
            }
            else {
                // TODO this must return the undefined
                // key in case we are in development mode.
                // TODO In production it should always
                // return "" if the key is not defined.
                // or return a default value if possible
                // return 'UNDEFINED KEY: ' + key;
                return undefined;
            }
        })), filter((/**
         * @param {?} text
         * @return {?}
         */
        (text) => text !== undefined)));
    }
}
InjectedTextPipe.decorators = [
    { type: Pipe, args: [{ name: 'injectedText' },] }
];
/** @nocollapse */
InjectedTextPipe.ctorParameters = () => [
    { type: Store }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    InjectedTextPipe.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/injectedText.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InjectedTextFeautureModule {
}
InjectedTextFeautureModule.decorators = [
    { type: NgModule, args: [{
                declarations: [InjectedTextPipe],
                imports: [
                    StoreModule.forFeature(featureKey, reducer)
                ],
                exports: [InjectedTextPipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/stringInjection/injectedText.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InjectedTextProvider {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
    }
    /**
     * @param {?} injectedText
     * @return {?}
     */
    setInjectedText(injectedText) {
        this.store.dispatch(onLocalizationsLoadedSuccessfully({
            payload: injectedText
        }));
    }
}
InjectedTextProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
InjectedTextProvider.ctorParameters = () => [
    { type: Store }
];
/** @nocollapse */ InjectedTextProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function InjectedTextProvider_Factory() { return new InjectedTextProvider(ɵɵinject(Store)); }, token: InjectedTextProvider, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    InjectedTextProvider.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/langauge/language.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:modeso-core:LanguageInterceptor');
/** @type {?} */
const LANGUAGE_PROVIDER = new InjectionToken('LanguageInterceptor');
/**
 * @record
 */
function ILanguageProvider() { }
if (false) {
    /**
     * @return {?}
     */
    ILanguageProvider.prototype.getCurrentLanguage = function () { };
}
class LanguageInterceptor {
    /**
     * @param {?} languageProvider
     */
    constructor(languageProvider) {
        this.languageProvider = languageProvider;
    }
    /**
     * intercept auttomatically all http request to the backend
     * and set the content-language header according to current language from url
     * @param {?} req
     * @param {?} next // to call next interceptor
     * @return {?}
     */
    intercept(req, next) {
        /** @type {?} */
        const modifiedReq = req.clone({
            setHeaders: {
                'content-language': this.languageProvider.getCurrentLanguage()
            }
        });
        debug('add language to request... ' + this.languageProvider.getCurrentLanguage());
        return next.handle(modifiedReq);
    }
}
LanguageInterceptor.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LanguageInterceptor.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [LANGUAGE_PROVIDER,] }] }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    LanguageInterceptor.prototype.languageProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/features/langauge/browser-language.interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LanguageHandler {
    constructor() {
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    intercept(request, next) {
        // getting the language of the browser
        /** @type {?} */
        const browserLanguage = navigator.language;
        /** @type {?} */
        let headerLanguage = '';
        if (browserLanguage.includes('de')) {
            headerLanguage = 'de-ch';
        }
        else if (browserLanguage.includes('fr')) {
            headerLanguage = 'fr-ch';
        }
        else if (browserLanguage.includes('it')) {
            headerLanguage = 'it-ch';
        }
        else {
            headerLanguage = 'en-us';
        }
        /** @type {?} */
        const languageReq = request.clone({
            headers: request.headers.set('content-language', headerLanguage)
        });
        return next.handle(languageReq);
    }
}
LanguageHandler.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LanguageHandler.ctorParameters = () => [];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-modeso-lib-core-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ConfigService, InjectedTextFeautureModule, InjectedTextPipe, InjectedTextProvider, LANGUAGE_PROVIDER, LanguageHandler, LanguageInterceptor, ModesoCoreModule, ModesoCoreService, NamedString, adapter, featureKey, getLocalizationByKey, getLocalizations, initialState, onLocalizationByKeyLoadedSuccessfully, onLocalizationByKeyLoadingFailed, onLocalizationsLoadedSuccessfully, onLocalizationsLoadingFailed, reducer, selectAll, selectContentAllEntities, selectContentId, selectEntities, selectEntitiesByID, selectFeature, selectFeatureContent, selectIds, selectLocalizationEntities, selectTotal, sortById };
